<template>
  <div class="participants">
    <a-button-box
      :active="state.matches('participants.visible')"
    >
      <a-button
        ref="toggle"
        variant="link-primary"
        @click="toggleHandler"
      >
        <a-icon name="people" />
        <a-badge :value="session.users.length" class="ms--1" />
      </a-button>
    </a-button-box>
    <Transition name="fade">
      <div
        class="box mb--0 mt--1"
        v-show="state.matches('participants.visible')"
        ref="target"
      >
        <div class="box__header">
          <h2>{{ $t('participants.title') }}</h2>
          <a-button
            v-if="user.isAssistant"
            variant="link-primary"
            class="p--0 "
            @click="addMemberHandler">
            <a-icon name="plus-circle" />
          </a-button>
        </div>
        <div class="box__content">
          <a-participants></a-participants>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useSessionStore, useUserStore, useAppStore } from '@/stores'
import { useMeetingMachine } from '@/state'
import { onClickOutside } from '@vueuse/core'
import AParticipants from '@/components/AParticipants.vue'

const app = useAppStore()
const session = useSessionStore()
const user = useUserStore()
const { state, send } = useMeetingMachine()
const toggle = ref(null)
const target = ref(null)

function toggleHandler () {
  if (state.value.matches('participants.visible')) {
    send('HIDE_PARTICIPANTS')
  } else {
    send('SHOW_PARTICIPANTS')
  }
}

function addMemberHandler () {
  const { conference: callId } = session
  const { configuration: { session: { detailUrl }}} = app
  const url = detailUrl.replace('{{callId}}', callId)
  window.open(url, '_blank')
}

onClickOutside(target, (event) => {
  if (state.value.matches('participants.visible') && event.target !== toggle.value.$el) {
    send('HIDE_PARTICIPANTS')
  }
})
</script>

<style lang="scss">
$participants-max-width: calc(100vw - #{$box-spacer * 2});
$participants-width-breakpoint-sm: calc(100vw - #{$box-spacer * 3.6});

.participants {
  position: relative;
  .box {
    position: absolute;
    top: 100%;
    right: 0;
    max-width: $participants-max-width;
    max-height: calc(100dvh - #{$component-height + $box-spacer + map-get($spacers, 2)} - 3.625rem); // TODO: tools height variable
    overflow: auto;
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: sticky;
      top: 0; left: 0;
      width: 100%;
      padding-bottom: $box-spacer;
      z-index: 1;
      .btn {
        position: relative;
        top: 0;
        right: 0;
      }
    }
  }
  @media (max-width: $breakpoint-sm) {
    .box {
      width: $participants-width-breakpoint-sm;
    }
  }
}
</style>
